// The RFI statuses as the tab shows them (back/models/rfi STATUSES).
export const STATUS = {
  draft: { label: "Draft", color: "default" },
  review: { label: "In review", color: "gold" },
  approved: { label: "Approved", color: "green" },
  submitted: { label: "Submitted", color: "blue" },
  answered: { label: "Answered", color: "purple" },
};
